import { useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import TabsCarousel, { CarouselTabsProps } from '@components/TabsCarousel'
import alertsApi from '@modules/alerts/api'
import { useAuthContext } from '@modules/auth/hooks/useAuthContext'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

import updatesApi from './api'
import ManagePage from './components/Manage'
import Updates from './components/Updates'
import { PageWrapper, TabsWrapper, TopTabsNavigationContainer } from './index.styles'

const AlertsPage = () => {
  const navigate = useNavigate()

  const { user } = useAuthContext()

  const { tab: initialTab } = useParams<{ tab: 'updates' | 'manage' }>()

  const { data: alertsShortlist, isLoading } = useQuery({
    queryKey: [alertsApi.fetchAlertsShortlist.key],
    queryFn: () => alertsApi.fetchAlertsShortlist.fn(),
    enabled: !!user?.id,
    placeholderData: keepPreviousData,
  })

  const { data: updatesUnreadCount } = useQuery({
    queryKey: [updatesApi.getUpdatesUnreadCount.key],
    queryFn: () => updatesApi.getUpdatesUnreadCount.fn(),
    enabled: !!user?.id,
    placeholderData: keepPreviousData,
  })

  const tabs = useMemo<CarouselTabsProps['tabs']>(
    () => [
      {
        id: 1,
        label: 'Updates',
        key: 'updates',
        tabId: 'alert_navigation-updates_tab',
      },
      {
        id: 2,
        key: 'manage',
        label: 'Manage alerts',
        disabled: !alertsShortlist?.profiles?.length,
        tabId: 'alert_navigation-manage_alerts_tab-updates_tab',
      },
    ],
    [alertsShortlist?.profiles?.length],
  )

  const selectedTab = tabs.find(tab => tab.key === initialTab!) ?? tabs[0]

  const handleSelectTab = (id: number) => {
    const selected = tabs.find(tab => tab.id === id) ?? tabs[0]
    navigate(`/plus/alerts/${selected.key}`)
  }

  const checkIsBadgeShouldBeDisplayed = (key: string) => {
    return key === 'updates'
  }

  const unreadUpdatesCount = useMemo(() => {
    if (!updatesUnreadCount?.unreadCount) {
      return ''
    }

    if (updatesUnreadCount?.unreadCount > 99) {
      return '99+'
    }

    return `${updatesUnreadCount?.unreadCount}`
  }, [updatesUnreadCount])

  return (
    <PageWrapper>
      {!isLoading && (
        <>
          <TopTabsNavigationContainer>
            <TabsWrapper>
              <TabsCarousel
                tabs={tabs}
                value={selectedTab.id}
                onChange={handleSelectTab}
                badgeContent={unreadUpdatesCount}
                checkIsBadgeShouldBeDisplayed={checkIsBadgeShouldBeDisplayed}
              />
            </TabsWrapper>
          </TopTabsNavigationContainer>
          {selectedTab.id === tabs[0].id ? (
            <Updates alertsAreSet={!!alertsShortlist?.profiles?.length} />
          ) : (
            <ManagePage alertsListId={alertsShortlist?.id} />
          )}
        </>
      )}
    </PageWrapper>
  )
}
export default AlertsPage
